import { normalizeSearchString } from '../../utils/normalizeSearchString';

export const getUserPropertyValue = function(user, name, _def = null) {
  return user?.properties?.find(prop => prop.name.name == name)?.value || _def;
};

export function parseUser(user) {
  for (let i = 0; i < user.properties.length; i++) {
    const prop = user.properties[i];
    user[prop.name.name] = prop.value;
  }
  user.__search = normalizeSearchString(user.name);
  return user;
}

const parseUserCompany = (company) => {
  const props = {};
  for (let i = 0; i < (company?.properties || []).length; i++) {
    try {
      props[company.properties[i].name.name] = JSON.parse(company.properties[i].value);
    } catch (err) {
      props[company.properties[i].name.name] = company.properties[i].value;
    }
  }

  return { ...company, ...props };
};

export const parseStoreUser = function(user, index) {
  let props = {};
  let properties = [];
  for (let i = 0; i < user.properties?.length; ++i) {
    if (!['address', 'company', 'weblogin'].includes(user.properties[i].name.name)) {
      props[user.properties[i].name.name] = user.properties[i].value;
      properties.push(user.properties[i]);
    }
  }

  let companies = [];
  if (user.companies?.length) {
    companies = user.companies.map(parseUserCompany);
  }

  return { ...user, ...props, properties, companies };
};
